"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onOrientation = onOrientation;
exports.enableDeviceMotion = enableDeviceMotion;
exports.updateDeviceMotion = updateDeviceMotion;
exports.getDeviceTilt = getDeviceTilt;
let tiltX = 0;
let targetTiltX = 0;
let enabled = false;
const MAX_TILT = 35;
function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
function onOrientation(event) {
    if (event.beta === null || event.gamma === null)
        return;
    const angle = screen.orientation?.angle ??
        (typeof window.orientation === 'number'
            ? window.orientation
            : 0);
    const radians = angle * Math.PI / 180;
    // Transform tilt into screen coordinates
    const x = event.gamma * Math.cos(radians) -
        event.beta * Math.sin(radians);
    targetTiltX = clamp(x / MAX_TILT, -1, 1);
}
let permissionPending = null;
function enableDeviceMotion() {
    if (enabled)
        return Promise.resolve(true);
    if (permissionPending)
        return permissionPending;
    const Orientation = window.DeviceOrientationEvent;
    if (!Orientation)
        return Promise.resolve(false);
    const attach = () => { window.addEventListener('deviceorientation', onOrientation); enabled = true; return true; };
    if (!Orientation.requestPermission)
        return Promise.resolve(attach());
    // Invoke synchronously within a tap, before any await loses user activation.
    try {
        permissionPending = Orientation.requestPermission().then(result => result === 'granted' ? attach() : false)
            .catch(() => false).finally(() => { permissionPending = null; });
        return permissionPending;
    }
    catch {
        return Promise.resolve(false);
    }
}
function updateDeviceMotion(dt) {
    const smoothing = 1 - Math.exp(-4 * dt);
    tiltX += (targetTiltX - tiltX) * smoothing;
}
function getDeviceTilt() {
    return tiltX;
}
//# sourceMappingURL=deviceMotion.js.map